import Vue from 'vue';

const preventSymbols = (e) => {
  const evalue = (e.ctrlKey || e.altKey
    || (e.keyCode > 47 && e.keyCode < 58 && e.shiftKey === false)
    || (e.keyCode > 95 && e.keyCode < 106)
    || (e.keyCode === 8) || (e.keyCode === 9)
    || (e.keyCode > 34 && e.keyCode < 40)
    || (e.keyCode === 46));
  if (evalue) {
    e.returnValue = true;
  } else {
    e.preventDefault();
  }
};

const preventPaste = (e) => {
  e.preventDefault();
  const text = e.clipboardData.getData('text');
  const numbers = text.replace(/\D*/g, '');

  if (document.queryCommandSupported('insertText')) {
    document.execCommand('insertText', false, numbers);
  } else {
    document.execCommand('paste', false, numbers);
  }
};

const onlyNumbers = {
  bind(el) {
    el.addEventListener('keydown', preventSymbols);
    el.addEventListener('paste', preventPaste);
  },
  unbind(el) {
    el.removeEventListener('keydown', preventSymbols);
    el.removeEventListener('paste', preventPaste);
    // do clean up work
    // e.g. remove event listeners added in bind()
  }
};
Vue.directive('only-numbers', onlyNumbers);
